import React from 'react';

import Icon from '@ant-design/icons';
import cx from 'classnames';

import { ReactComponent as AlertSvg } from '../../../../../assets/sightx-icons/svg/sx-alert-circle.svg';

import styles from './index.module.scss';

type Type = 'error' | 'warning';
export type AlertType = Type;

interface Props {
  message: string;
  type?: Type;
}

export const Alert: React.FC<Props> = ({ message, type = 'warning' }) => {
  return (
    <div className={cx(styles.main, styles[type])}>
      <div className={styles.iconWrapper}>
        <Icon className={styles.icon} component={AlertSvg} />
      </div>
      <div>
        { message }
      </div>
    </div>

  );
};
